<template>
  <page-header-wrapper>
    <a-card :bordered='false'>
      <!-- 条件搜索 -->
      <div class='table-page-search-wrapper'>
        <a-form layout='inline'>
          <a-row :gutter='48'>
            <a-col :md='5' :sm='24'>
              <a-form-item label='昵称' prop='password'>
                <a-input v-model='queryParam.nickname' placeholder='请输入昵称'
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md='4' :sm='24'>
              <a-form-item label='手机号' prop='mobile'>
                <a-input v-model='queryParam.mobile' placeholder='请输入手机号'
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md='7' :sm='24'>
              <a-form-item label='优惠券券码' prop='couponCode'>
                <a-input v-model='queryParam.couponCode' placeholder='请输入券码'
                         allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md='!advanced && 8 || 24' :sm='24'>
              <span class='table-page-search-submitButtons'
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type='primary' @click='handleQuery'><a-icon type='search' />查询</a-button>
                <a-button style='margin-left: 8px' @click='resetQuery'><a-icon type='redo' />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class='table-operations'>
<!--        v-hasPermi="['user:user:add']"-->
        <a-button type='primary' @click='$refs.createForm.handleAdd()'
                  >
          <a-icon type='plus' />
          新增
        </a-button>
<!--        <a-button type='primary' :disabled='single' @click='$refs.createForm.handleUpdate(undefined, ids)'-->
<!--                  v-hasPermi="['user:user:edit']">-->
<!--          <a-icon type='edit' />-->
<!--          修改-->
<!--        </a-button>-->
<!--        v-hasPermi="['user:user:remove']"-->
        <a-button type='danger' :disabled='multiple' @click='handleDelete'
                  >
          <a-icon type='delete' />
          删除
        </a-button>
<!--        <a-button type='primary' @click='handleExport' v-hasPermi="['biz:user:export']">-->
<!--          <a-icon type='download' />-->
<!--          导出-->
<!--        </a-button>-->
        <a-button type="dashed" @click="$refs.importUserExcel.importExcelHandleOpen()" >
          <a-icon type="import" />导入
        </a-button>
        <input
          id="fileUploadPDF"
          ref="filElemPDF"
          multiple="multiplt"
          style="display: none"
          type="file"
          @change="getFilePDF"
        />
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync='tableSize'
          v-model='columns'
          :refresh-loading='loading'
          @refresh='getList' />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref='createForm'
        @ok='getList'
      />
      <import-user-excel ref="importUserExcel" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading='loading'
        :size='tableSize'
        rowKey='id'
        :columns='columns'
        :data-source='list'
        :row-selection='{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }'
        :pagination='false'
        :bordered='tableBordered'
      >
        <span slot="img" slot-scope="text,record">
          <img :src="record.avatar" style="width: 80px;height: 80px;"/>
        </span>
                <span slot='vipLoseTime' slot-scope='text, record'>
          {{ parseTime(record.vipLoseTime) }}
        </span>
        <span slot='createTime' slot-scope='text, record'>
          {{ parseTime(record.createTime) }}
        </span>
        <span slot='operation' slot-scope='text, record'>
<!--          v-hasPermi="['user:user:edit']"-->
          <a-divider type='vertical'  />
          <a @click='$refs.createForm.handleUpdate(record, undefined)'
             >
            <a-icon type='edit' />修改
          </a>
<!--          v-hasPermi="['user:user:remove']"-->
          <a-divider type='vertical'  />
          <a @click='handleDelete(record)' >
            <a-icon type='delete' />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class='ant-table-pagination'
        show-size-changer
        show-quick-jumper
        :current='queryParam.pageNum'
        :total='total'
        :page-size='queryParam.pageSize'
        :showTotal='total => `共 ${total} 条`'
        @showSizeChange='onShowSizeChange'
        @change='changeSize'
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser } from '@/api/user/user'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import ImportUserExcel from './modules/ImportUserExcel'
import ImportExcel from '@/views/system/user/modules/ImportExcel.vue'
export default {
  name: 'User',
  components: {
    ImportExcel,
    CreateForm,
    ImportUserExcel
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        nickname: null,
        couponCode: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          ellipsis: true,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'img' }
        },

        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if(value == 1){
              return "男"
            }else if(value == 2){
              return "女"
            }
            return "保密"
          }
        },
        {
          title: '是否会员',
          dataIndex: 'isVip',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if(value == 1){
              return "是"
            }
            return "否"
          }
        },
        {
          title: '优惠券券码',
          dataIndex: 'couponCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'vip过期时间',
          dataIndex: 'vipLoseTime',
          scopedSlots: { customRender: 'vipLoseTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: null,
        nickname: null,
        couponCode: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    /** 导如按钮操作 */
    handleImportExport() {
      //给输入框添加自定义触发事件，使用dispatchEvent来进行手动触发
      this.$refs.filElemPDF.dispatchEvent(new MouseEvent('click'))
      this.$refs.filElemPDF.value = null
    },
    getFilePDF (e) {
      let file = e.target.files
      for (let i = 0; i < file.length; i++) {
        //取出上传文件的扩展名
        let flag = false
        let index = file[i].name.lastIndexOf('.')
        let ext = file[i].name.substr(index + 1)
        let name = file[i].name
        if (ext == 'xlsx') {
          let that = this
          let formData = new FormData()
          formData.append('files', file[i]) // 文件对象
          //调用导入后台接口
          debugger
          // httpAction('/goods/goods/importXls', formData, 'post').then((res) => {
          //   debugger
          //   e.target.value = ''
          //   if (res.success) {
          //     that.$message.success(res.message)
          //     that.$emit('ok')
          //   } else {
          //     that.$message.warning(res.message)
          //   }
          // })
        } else {
          this.$message.warning('仅支持.xlsx表格导入!')
        }
      }
    },
  }
}
</script>
